<template>
    <div v-if="modalData.showModal" class='sm-modal-parent'>
        <div  class='inl-100 small-modal'>
            <div v-if="modalData.showModal"
                class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
                <div class="relative w-auto my-6 mx-auto max-w-sm">
                    <!--content-->
                    <div
                        style="width: 500px;"
                        class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <!--header-->
                        <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                            <h3 class="text-3xl font-semibold">
                                {{ modalData.title }}
                            </h3>
                            <button
                                class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                v-on:click="modalClose">
                                <span
                                    class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                    ×
                                </span>
                            </button>
                        </div>
                        <!--body-->
                        <div style="width: 500px;" class="relative p-6 flex-auto">
                            <p style="margin: 20px auto;" class="inl-90 my-4 text-blueGray-500 text-lg leading-relaxed">
                                <ul>
                                    <li v-for="(elem, ind) in modalData.messages" :key="ind">
                                        {{ ind+1 }}. 
                                        <span v-if="elem.title"> {{ elem.title }}: {{ elem.message }}</span>
                                        <span v-else> {{ elem.message }}</span>
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <!--footer-->
                        <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                            <button
                                :class="[ !modalData.isError ? 'bg-emerald-500 active:bg-emerald-600 ' : 'bg-red-500 active:bg-red-600 ',  'text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150']"
                                type="button" v-on:click="modalClose">
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if="modalData.showModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div> -->
        </div>
    </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex'

export default {
    name: "small-modal",
    computed: mapState(['modalData']),
    data() {
        return {
        }
    },
    methods: {
        ...mapMutations(['modalClose']),
    }
}
</script>

<style scoped>
    .sm-modal-parent {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .small-modal {
        position: absolute;
        margin: 0;
        z-index: 99999;
    }
</style>